// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: row;
  gap: 0;
  width: 100%;
  height: 100%;
}

.left-content {
  width: 700px;
  display: flex;
  flex-direction: column;
  background: var(--ion-color-light);
  padding: 25px;
  overflow-y: auto;
  height: 100vh;
}
.left-content ion-card {
  margin-bottom: 24px;
}
.left-content ion-card ion-card-header {
  background: #fff;
  border-bottom: 1px solid var(--ion-color-light);
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  padding: 20px;
  gap: 10px;
}
.left-content ion-card ion-card-header ion-icon {
  font-size: 20px;
}
.left-content ion-card ion-card-header p {
  font-weight: 600;
  color: var(--ion-color-dark);
  font-size: 15px;
}
.left-content ion-card ion-card-header ion-button {
  margin: 0;
  margin-left: auto;
  height: 20px;
  --padding-end: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  --padding-start: 0;
}
.left-content .amount {
  padding: 0 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}
.left-content .amount h1 {
  font-size: 50px;
  font-weight: 700;
  z-index: 11;
  position: relative;
}
.left-content .amount .pending-lbl {
  color: var(--ion-color-medium);
  font-size: 22px;
  margin-top: 10px;
  z-index: 11;
  position: relative;
  font-weight: 500;
}
.left-content .amount .pending-lbl span {
  font-weight: 600;
  color: var(--ion-color-primary);
  font-size: 22px;
}
.left-content .amount .split-lbl {
  font-size: 13px;
  margin-bottom: 16px;
  background: #e4eaee;
  padding: 10px 15px;
  border-radius: 6px;
  font-weight: 600;
  z-index: 11;
  position: relative;
  width: fit-content;
}
.left-content .order-data ion-grid {
  margin-bottom: -13px;
}
.left-content .order-data ion-card-content {
  padding: 0 16px !important;
}
.left-content .order-data ion-card-content ion-grid {
  padding: 0;
}
.left-content .order-data ion-card-content ion-grid ion-row {
  border-bottom: 1px solid var(--ion-color-light);
}
.left-content .order-data ion-card-content ion-grid ion-row ion-col {
  padding: 16px 0;
  color: var(--ion-color-medium);
}
.left-content .order-data ion-card-content ion-grid ion-row .data-info {
  color: black !important;
  text-transform: capitalize;
}
.left-content .order-data ion-card-content ion-grid ion-row .data-total {
  color: var(--ion-color-primary);
}
.left-content .order-data ion-card-content ion-grid ion-row ion-button {
  height: 19px;
  --padding-start: 0;
  margin-left: -8px;
}
.left-content ion-item ion-icon {
  font-size: 27px;
}

.right-content {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.right-content .title {
  padding: 40px;
  padding-bottom: 8px !important;
  margin-bottom: 0 !important;
}
.right-content .title h1 {
  font-size: 35px;
  font-weight: 600;
}
.right-content .title p {
  font-size: 20px;
}
.right-content .title ion-button {
  position: absolute;
  top: 0;
  right: 0;
  --border-radius: 50px;
  width: 40px;
  height: 40px;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  margin: 32px;
}
.right-content .title ion-button ion-icon {
  font-size: 20px;
}
.right-content .options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  height: 100%;
  margin: 40px;
}
.right-content .options ion-card {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #ebeff8;
  border-radius: 12px;
  text-align: center;
  margin: 0;
  padding: 16px;
  height: 100%;
  cursor: pointer;
}
.right-content .options ion-card ion-icon {
  font-size: 70px;
  margin-bottom: 32px;
}
.right-content .options ion-card p {
  font-size: 17px;
  color: black;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 16px;
}
.right-content .options ion-card p span {
  font-size: 15px;
  font-weight: 600;
}
@media (max-width: 767px) {
  .right-content .options {
    grid-template-columns: repeat(2, 1fr) !important;
    height: calc(100% - 63.8px);
    margin: 8px !important;
    margin-top: 16px;
  }
  .right-content .options ion-icon {
    font-size: 50px !important;
  }
  .right-content .options p {
    font-size: 15px !important;
  }
  .right-content .options ion-card {
    height: 200px;
  }
}

.line {
  height: 100%;
  width: 1px;
  background: #ebeff8;
  margin: 0 16px;
}

.option-disabled {
  cursor: no-drop;
}
.option-disabled ion-icon,
.option-disabled ion-label {
  opacity: 0.6;
}

.others,
.types {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.show-board {
  display: flex !important;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0.5;
  background: var(--ion-color-dark);
  -webkit-backdrop-filter: blur(50px);
          backdrop-filter: blur(50px);
  z-index: 111111;
  display: flex;
  align-items: center;
  justify-content: center;
}
.show-board h1 {
  color: white;
  text-align: center;
  font-size: 25px;
}

.hide-board {
  display: none;
}

.close-btn {
  display: flex;
  gap: 10px;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1111;
  --border-radius: 50px !important;
  width: 50px;
  height: 50px;
}
.close-btn ion-icon {
  font-size: 20px !important;
}

@media (max-width: 767px) {
  .container {
    display: block;
  }
  .left-content {
    width: 100%;
    padding: 16px !important;
    height: unset !important;
    padding-top: calc(env(safe-area-inset-top) + 32px) !important;
  }
  .right-content {
    width: 100%;
    height: unset !important;
    padding-bottom: env(safe-area-inset-bottom);
    overflow: unset;
  }
  .right-content .title {
    padding: 16px;
    padding-top: 32px;
  }
  .right-content .title h1 {
    font-size: 25px !important;
  }
  .right-content .title p {
    font-size: 16px !important;
  }
  .right-content .options {
    padding: 8px;
  }
  .right-content .options ion-row ion-col {
    padding: 8px;
    height: unset !important;
  }
  .right-content .options .option ion-label {
    font-size: 14px !important;
  }
  .close-btn {
    --background: #ebeef1;
    --background-hover: #ebeef1;
    --background-activated: #ebeef1;
    top: env(safe-area-inset-top) !important;
    right: 16px !important;
    position: fixed;
  }
}
.payment {
  padding: 10px 16px;
  padding-bottom: 0;
  --padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/payment-method/payment-method.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AACD;;AAEA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AACD;AACC;EACC,mBAAA;AACF;AACE;EACC,gBAAA;EACA,+CAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;AACH;AACG;EACC,eAAA;AACJ;AAEG;EACC,gBAAA;EACA,4BAAA;EACA,eAAA;AAAJ;AAGG;EACC,SAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAMC;EACC,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAJF;AAME;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAJH;AAOE;EACC,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AALH;AAOG;EACC,gBAAA;EACA,+BAAA;EACA,eAAA;AALJ;AASE;EACC,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAPH;AAYE;EACC,oBAAA;AAVH;AAaE;EACC,0BAAA;AAXH;AAaG;EACC,UAAA;AAXJ;AAaI;EACC,+CAAA;AAXL;AAaK;EACC,eAAA;EACA,8BAAA;AAXN;AAcK;EACC,uBAAA;EACA,0BAAA;AAZN;AAeK;EACC,+BAAA;AAbN;AAgBK;EACC,YAAA;EACA,kBAAA;EACA,iBAAA;AAdN;AAsBE;EACC,eAAA;AApBH;;AAyBA;EACC,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAtBD;AAwBC;EACC,aAAA;EACA,8BAAA;EACA,2BAAA;AAtBF;AAwBE;EACC,eAAA;EACA,gBAAA;AAtBH;AAyBE;EACC,eAAA;AAvBH;AA0BE;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAxBH;AA0BG;EACC,eAAA;AAxBJ;AA6BC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AA3BF;AA6BE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AA3BH;AA6BG;EACC,eAAA;EACA,mBAAA;AA3BJ;AA8BG;EACC,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AA5BJ;AA8BI;EACC,eAAA;EACA,gBAAA;AA5BL;AAmCC;EACC;IACC,gDAAA;IACA,2BAAA;IACA,sBAAA;IACA,gBAAA;EAjCD;EAmCC;IACC,0BAAA;EAjCF;EAoCC;IACC,0BAAA;EAlCF;EAqCC;IACC,aAAA;EAnCF;AACF;;AAwCA;EACC,YAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;AArCD;;AAwCA;EACC,eAAA;AArCD;AAuCC;;EAEC,YAAA;AArCF;;AAyCA;;EAEC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAtCD;;AAyCA;EACC,wBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;EACA,iCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtCD;AAwCC;EACC,YAAA;EACA,kBAAA;EACA,eAAA;AAtCF;;AA0CA;EACC,aAAA;AAvCD;;AA0CA;EACC,aAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;AAvCD;AAyCC;EACC,0BAAA;AAvCF;;AA2CA;EACC;IACC,cAAA;EAxCA;EA2CD;IACC,WAAA;IACA,wBAAA;IACA,wBAAA;IACA,6DAAA;EAzCA;EA4CD;IACC,WAAA;IACA,wBAAA;IACA,2CAAA;IACA,eAAA;EA1CA;EA4CA;IACC,aAAA;IACA,iBAAA;EA1CD;EA4CC;IACC,0BAAA;EA1CF;EA6CC;IACC,0BAAA;EA3CF;EA+CA;IACC,YAAA;EA7CD;EAgDE;IACC,YAAA;IACA,wBAAA;EA9CH;EAmDE;IACC,0BAAA;EAjDH;EAuDD;IACC,qBAAA;IACA,2BAAA;IACA,+BAAA;IACA,wCAAA;IACA,sBAAA;IACA,eAAA;EArDA;AACF;AAwDA;EACC,kBAAA;EACA,iBAAA;EACA,sBAAA;AAtDD","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.left-content {\n\twidth: 700px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: var(--ion-color-light);\n\tpadding: 25px;\n\toverflow-y: auto;\n\theight: 100vh;\n\n\tion-card {\n\t\tmargin-bottom: 24px;\n\n\t\tion-card-header {\n\t\t\tbackground: #fff;\n\t\t\tborder-bottom: 1px solid var(--ion-color-light);\n\t\t\ttext-align: left;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tflex-direction: row;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 20px;\n\t\t\tgap: 10px;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--ion-color-dark);\n\t\t\t\tfont-size: 15px;\n\t\t\t}\n\n\t\t\tion-button {\n\t\t\t\tmargin: 0;\n\t\t\t\tmargin-left: auto;\n\t\t\t\theight: 20px;\n\t\t\t\t--padding-end: 0;\n\t\t\t\t--padding-bottom: 0;\n\t\t\t\t--padding-top: 0;\n\t\t\t\t--padding-start: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t.amount {\n\t\tpadding: 0 10px;\n\t\ttext-align: center;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tmargin-bottom: 32px;\n\n\t\th1 {\n\t\t\tfont-size: 50px;\n\t\t\tfont-weight: 700;\n\t\t\tz-index: 11;\n\t\t\tposition: relative;\n\t\t}\n\n\t\t.pending-lbl {\n\t\t\tcolor: var(--ion-color-medium);\n\t\t\tfont-size: 22px;\n\t\t\tmargin-top: 10px;\n\t\t\tz-index: 11;\n\t\t\tposition: relative;\n\t\t\tfont-weight: 500;\n\n\t\t\tspan {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\tfont-size: 22px;\n\t\t\t}\n\t\t}\n\n\t\t.split-lbl {\n\t\t\tfont-size: 13px;\n\t\t\tmargin-bottom: 16px;\n\t\t\tbackground: #e4eaee;\n\t\t\tpadding: 10px 15px;\n\t\t\tborder-radius: 6px;\n\t\t\tfont-weight: 600;\n\t\t\tz-index: 11;\n\t\t\tposition: relative;\n\t\t\twidth: fit-content;\n\t\t}\n\t}\n\n\t.order-data {\n\t\tion-grid {\n\t\t\tmargin-bottom: -13px;\n\t\t}\n\n\t\tion-card-content {\n\t\t\tpadding: 0 16px !important;\n\n\t\t\tion-grid {\n\t\t\t\tpadding: 0;\n\n\t\t\t\tion-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-light);\n\n\t\t\t\t\tion-col {\n\t\t\t\t\t\tpadding: 16px 0;\n\t\t\t\t\t\tcolor: var(--ion-color-medium);\n\t\t\t\t\t}\n\n\t\t\t\t\t.data-info {\n\t\t\t\t\t\tcolor: black !important;\n\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t}\n\n\t\t\t\t\t.data-total {\n\t\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\t}\n\n\t\t\t\t\tion-button {\n\t\t\t\t\t\theight: 19px;\n\t\t\t\t\t\t--padding-start: 0;\n\t\t\t\t\t\tmargin-left: -8px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\tion-item {\n\t\tion-icon {\n\t\t\tfont-size: 27px;\n\t\t}\n\t}\n}\n\n.right-content {\n\theight: 100vh;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: auto;\n\n\t.title {\n\t\tpadding: 40px;\n\t\tpadding-bottom: 8px !important;\n\t\tmargin-bottom: 0 !important;\n\n\t\th1 {\n\t\t\tfont-size: 35px;\n\t\t\tfont-weight: 600;\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 20px;\n\t\t}\n\n\t\tion-button {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\t--border-radius: 50px;\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t\t--padding-top: 0;\n\t\t\t--padding-bottom: 0;\n\t\t\t--padding-start: 0;\n\t\t\t--padding-end: 0;\n\t\t\tmargin: 32px;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.options {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 16px;\n\t\theight: 100%;\n\t\tmargin: 40px;\n\n\t\tion-card {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tflex-direction: column;\n\t\t\tborder: 1px solid #ebeff8;\n\t\t\tborder-radius: 12px;\n\t\t\ttext-align: center;\n\t\t\tmargin: 0;\n\t\t\tpadding: 16px;\n\t\t\theight: 100%;\n\t\t\tcursor: pointer;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 70px;\n\t\t\t\tmargin-bottom: 32px;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 17px;\n\t\t\t\tcolor: black;\n\t\t\t\tfont-weight: 600;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tmargin: 0 16px;\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\n\t@media (max-width: 767px) {\n\t\t.options {\n\t\t\tgrid-template-columns: repeat(2, 1fr) !important;\n\t\t\theight: calc(100% - 63.8px);\n\t\t\tmargin: 8px !important;\n\t\t\tmargin-top: 16px;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 50px !important;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 15px !important;\n\t\t\t}\n\n\t\t\tion-card {\n\t\t\t\theight: 200px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.line {\n\theight: 100%;\n\twidth: 1px;\n\tbackground: #ebeff8;\n\tmargin: 0 16px;\n}\n\n.option-disabled {\n\tcursor: no-drop;\n\n\tion-icon,\n\tion-label {\n\t\topacity: 0.6;\n\t}\n}\n\n.others,\n.types {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.show-board {\n\tdisplay: flex !important;\n\ttop: 0;\n\tleft: 0;\n\tposition: absolute;\n\topacity: 0.5;\n\tbackground: var(--ion-color-dark);\n\tbackdrop-filter: blur(50px);\n\tz-index: 111111;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\th1 {\n\t\tcolor: white;\n\t\ttext-align: center;\n\t\tfont-size: 25px;\n\t}\n}\n\n.hide-board {\n\tdisplay: none;\n}\n\n.close-btn {\n\tdisplay: flex;\n\tgap: 10px;\n\tposition: absolute;\n\ttop: 16px;\n\tright: 16px;\n\tz-index: 1111;\n\t--border-radius: 50px !important;\n\twidth: 50px;\n\theight: 50px;\n\n\tion-icon {\n\t\tfont-size: 20px !important;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.container {\n\t\tdisplay: block;\n\t}\n\n\t.left-content {\n\t\twidth: 100%;\n\t\tpadding: 16px !important;\n\t\theight: unset !important;\n\t\tpadding-top: calc(env(safe-area-inset-top) + 32px) !important;\n\t}\n\n\t.right-content {\n\t\twidth: 100%;\n\t\theight: unset !important;\n\t\tpadding-bottom: env(safe-area-inset-bottom);\n\t\toverflow: unset;\n\n\t\t.title {\n\t\t\tpadding: 16px;\n\t\t\tpadding-top: 32px;\n\n\t\t\th1 {\n\t\t\t\tfont-size: 25px !important;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 16px !important;\n\t\t\t}\n\t\t}\n\n\t\t.options {\n\t\t\tpadding: 8px;\n\n\t\t\tion-row {\n\t\t\t\tion-col {\n\t\t\t\t\tpadding: 8px;\n\t\t\t\t\theight: unset !important;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.option {\n\t\t\t\tion-label {\n\t\t\t\t\tfont-size: 14px !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.close-btn {\n\t\t--background: #ebeef1;\n\t\t--background-hover: #ebeef1;\n\t\t--background-activated: #ebeef1;\n\t\ttop: env(safe-area-inset-top) !important;\n\t\tright: 16px !important;\n\t\tposition: fixed;\n\t}\n}\n\n.payment {\n\tpadding: 10px 16px;\n\tpadding-bottom: 0;\n\t--padding-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
